import { useEffect } from 'react'

export default function useServiceWorker() {
  useEffect(() => {
    // window.workbox is created by next-pwa's register.js (still injected even
    // with register: false). We just call .register() with error handling so
    // failures on unreliable networks or in incognito mode don't produce
    // unhandled promise rejections.
    if (window.workbox) {
      window.workbox.register().catch((error) => {
        console.warn('Service worker registration failed:', error.message)
      })
    }
  }, [])
}
